"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var react_google_maps_1 = require("react-google-maps");

var noop = function noop() {};

var mapStyle = require('./map-style.json');

var iconImage = {
  url: 'https://s3-eu-west-1.amazonaws.com/perfocal-asset/maps/map-marker.png'
};
var photogIcon = {
  url: 'https://s3-eu-west-1.amazonaws.com/perfocal-asset/maps/photog-marker.png'
};
var google;

if (typeof window != 'undefined') {
  if (!!window["google"] && !!window["google"].maps) {
    google = window.google;
    iconImage.scaledSize = new google.maps.Size(40, 47.5);
    photogIcon.scaledSize = new google.maps.Size(20, 20);
  }
}

var mapOptions = {
  styles: mapStyle,
  mapTypeControl: false,
  streetViewControl: false,
  overviewMapControl: false,
  scaleControl: false,
  rotateControl: false,
  fullscreenControl: false
};

var Map = function (_super) {
  __extends(Map, _super);

  function Map() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Map.prototype.shouldComponentUpdate = function (nextProps) {
    var center = this.props.center;
    var nextCenter = nextProps.center;
    return nextCenter && nextCenter.lat !== center.lat && nextCenter.lng !== center.lng;
  };

  Map.prototype.render = function () {
    var props = this.props;
    var Component = react_google_maps_1.withGoogleMap(function (props) {
      var center = props.center,
          zoom = props.zoom,
          showMarker = props.showMarker;
      var photogPositions = !!props.photogPositions && props.photogPositions.length > 0 ? props.photogPositions : [];
      return React.createElement(react_google_maps_1.GoogleMap, {
        defaultCenter: center,
        defaultZoom: zoom || 7,
        defaultOptions: mapOptions,
        onClick: noop
      }, showMarker ? React.createElement(react_google_maps_1.Marker, {
        zIndex: 10000,
        position: center,
        defaultAnimation: !!google && google.maps.Animation.DROP,
        icon: iconImage
      }) : null, photogPositions.map(function (p, key) {
        return React.createElement(react_google_maps_1.Marker, {
          key: key,
          position: {
            lat: p.lat,
            lng: p.lng
          },
          defaultAnimation: !!google && google.maps.Animation.DROP,
          icon: photogIcon
        });
      }));
    });
    return React.createElement(Component, __assign({
      containerElement: React.createElement("div", {
        className: "map-container"
      }),
      mapElement: React.createElement("div", null)
    }, props));
  };

  return Map;
}(React.Component);

exports["default"] = Map;